import { fontFamily } from 'common/styles/styles.typography';
import { themedStyled } from 'common/styles/styletron.theme';

export const StyledTable = themedStyled('div', ({ $theme }) => ({
  borderSpacing: 0,
  borderCollapse: 'separate',
  fontFamily,
}));

export const StyledTD = themedStyled('div', ({ $theme }) => ({
  borderRight: `0.25px solid ${$theme.colors.skyLighter}`,
  borderBottom: `0.25px solid ${$theme.colors.borderOpaque}`,
  textAlign: 'left',
  padding: '0',
  overflow: 'auto',
  backgroundColor: $theme.colors.white,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
}));

export const StyledTR = themedStyled('div', ({ $theme }) => ({
  background: $theme.colors.white,
  minHeight: '44px',
  display: 'flex',
}));

export const StickyTopTH = themedStyled('div', ({ $theme }) => ({
  position: 'sticky',
  top: 0,
}));

export const StickyTopTR = themedStyled('div', ({ $theme }) => ({
  position: 'sticky',
  top: 0,
  display: 'flex',
}));

export const StickyTHead = themedStyled('div', ({ $theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 3,
  backgroundColor: $theme.colors.white,
}));

export const StyledTH = themedStyled('div', ({ $theme }) => ({
  height: '36px',
  padding: '8px',
  fontSize: '14px',
  fontWeight: '500',
  position: 'sticky',
  top: 0,
  userSelect: 'none',
  msUserSelect: 'none',
  MozUserSelect: 'none',
  msTouchSelect: 'none',
  WebkitUserSelect: 'none',
  backgroundColor: $theme.colors.white,

  borderRight: `0.25px solid ${$theme.colors.borderOpaque}`,
  // borderTop: `0.25px solid ${$theme.colors.borderOpaque}`,
  borderBottom: `0.25px solid ${$theme.colors.borderOpaque}`,
}));

export const StyledTBody = themedStyled('div', {
  fontSize: '13px',
});

export const TableContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
}));

export const TableOuter = themedStyled('div', {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  position: 'relative',
});

export const TableInner = themedStyled('div', {
  display: 'flex',
  position: 'absolute',
  flexDirection: 'column',
  inset: 0,
  overflow: 'hidden',
});

export const TableContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'auto',
}));

export const HeaderContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  width: '100%',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
});

export const ResizeBorder = themedStyled('div', ({ $theme }) => ({
  display: 'inline-block',
  background: $theme.colors.skyLighter,
  width: '1px',
  height: '100%',
  position: 'absolute',
  right: 0,
  top: 0,
  transform: 'translateX(50%)',
  zIndex: 1,
  touchAction: 'none',
  cursor: 'col-resize',
  ':hover': {
    backgroundColor: $theme.colors.skyDefault,
    width: '2px',
  },
  ':active': {
    backgroundColor: $theme.colors.skyDefault,
    width: '2px',
  },
}));

export const UncheckedBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderWidth: '1.6px',
    borderColor: $disabled ? $theme.colors.skyLight : $theme.colors.inkLightest,
    borderStyle: 'solid',
    borderRadius: '2px',
    margin: '2px',
  }),
);

export const IndeterminateBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderRadius: '2px',
    background: $disabled
      ? $theme.colors.skyLight
      : $theme.colors.primaryDefault,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
  }),
);

export const CheckedBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderRadius: '2px',
    background: $disabled
      ? $theme.colors.skyLight
      : $theme.colors.primaryDefault,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
  }),
);
